export default "__VITE_ASSET__DkZmGfz5__"